// MUI
import Box from '@mui/material/Box'

// Sections
import HeroSection from './sections/HeroSection'
import WhereWeWorkSection from './sections/WhereWeWorkSection'
import SystemViewSection from './sections/SystemViewSection'
import WhyItMattersSection from './sections/WhyItMattersSection'
import FocusSection from './sections/FocusSection'
import HowWeWorkSection from './sections/HowWeWorkSection'
import CtaSection from './sections/CtaSection'

// Style
import themeColors from 'assets/theme/colors'

export default function TechnologyView() {
  // *** MAIN RENDER ***
  return (
    <Box sx={{ background: themeColors.kroemtech.background }}>
      {/* The hero is full bleed, so it owns the padding that clears the
          fixed header. */}
      <HeroSection />

      <WhereWeWorkSection />
      <SystemViewSection />
      <WhyItMattersSection />
      <FocusSection />
      <HowWeWorkSection />
      <CtaSection />
    </Box>
  )
}
